import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import FilersCases from './FilersCases';
import filersArray from './filersArray';

const emptyProps = {
  case_uuid: 'azbtest_2644',
  purchase_right_away: false,
  filers: [],
  noDataFoundMessage: 'No parties have filed anything for this case',
  dataReady: true,
  dispatch: null,
  lastUpdated: 1000,
  error: null,
  receipt: null,
};

const samplefilersProps = {
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  filers: filersArray,
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
  type: 'schedule',
  sidebarData: {},
  kloudless: {},
};

storiesOf('Case Menu/Filers', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr />
      <FilersCases />
    </div>
  ))

  .add('View', () => (
    <div>
      <h3>By default, we show a list of filers received form the API</h3>
      <hr />
      <h4>Page contains 'Find What' input that searches through table of data.</h4>
      <h4>There is 'Premium Search' button, which leads to the premium search url.</h4>
      <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
      <hr />

      <FilersCases
        {...samplefilersProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ))

  .add('No Data', () => (
    <div>
      <h3>If there is no data found, message is displayed.</h3>
      <hr />
      <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
      <hr />

      <FilersCases {...emptyProps} />
    </div>
  ));




// WEBPACK FOOTER //
// ./src/components/case/filers/FilersCases.stories.jsx